export class AsyncFunctionException extends Error {
    constructor(message = AsyncFunctionException.MESSAGE) {
        super(message);
    }
}
AsyncFunctionException.MESSAGE = `'Iterable' can not used with async function.
If you want to deal with async function, see: [toAsync](https://fxts.dev/docs/toAsync)`;
//# sourceMappingURL=error.js.map